/**
 * 大数据查询 
 */
 import axios from 'axios'
 import fetch from "../fetch"
 import noticeUrl from '../urls/notice'
 
 export default {
    GetCategoryTree(data) { // 所有的菜单树
        return fetch({
            url: noticeUrl.GetCategoryTree,
            method: 'get',
            data,
        })
    },
    GetApiInfo(data) { // 获取分类Api信息
        return fetch({
            url: noticeUrl.GetApiInfo,
            method: 'get',
            data,
        })
    },
    ApiCodeInfo(data) { // 获取大数据查询代码信息
        return fetch({
            url: noticeUrl.ApiCodeInfo,
            method: 'post',
            data,
        })
    },
    GetBigDataList(data) { // 获取大数据查询数据列表
        return fetch({
            url: noticeUrl.GetBigDataList,
            method: 'post',
            data,
        })
    },
    GetTsCodeList(data) { // 获取ts_code 股票代码
        axios.defaults.baseURL = window.PUBLICPYTHON;
        let result = fetch({
            url: noticeUrl.GetTsCodeList,
            method: 'get',
            data,
        });
        axios.defaults.baseURL = window.PUBLICHOSTA;
        return result;
    },
  
}
 


// WEBPACK FOOTER //
// ./src/api/apis/notice.js